import React from "react";

import { markdownify } from "config/utils";

import { Wrapper, Inner, Title, Description, Image, Date } from "./styles";

const Article = ({ content }) => {
  return (
    <Wrapper href={content.path} target="_blank">
      {content.image && <Image content={content.image} height="160px" />}
      <Inner>
        <Title>{content.title}</Title>
        {content.description && (
          <Description
            dangerouslySetInnerHTML={{
              __html: markdownify(content.description)
            }}
          />
        )}
        {content.date && <Date>{content.date}</Date>}
      </Inner>
    </Wrapper>
  );
};

export default Article;
